import {get} from 'lodash';

export default (state = {}, payload: any) => {
  const healthcare = payload.healthcare || payload;
  return {
    ...state,
    healthcare: {
      ...get(state, 'healthcare', {}),
      data: {
        ...get(state, 'healthcare.data', {}),
        ...healthcare,
      },
    },
  };
};
